import React from 'react';

const Vacation = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9532 43.3617V4.82003C22.9532 4.26749 23.1728 3.73755 23.5635 3.34686C23.9541 2.95615 24.4841 2.73669 25.0366 2.73669C25.5891 2.73669 26.1191 2.95615 26.5097 3.34686C26.9003 3.73755 27.1199 4.26749 27.1199 4.82003V43.3617C27.1199 43.6379 27.0101 43.9029 26.8149 44.0982C26.6195 44.2936 26.3545 44.4034 26.0782 44.4034H23.9949C23.7187 44.4034 23.4537 44.2936 23.2582 44.0982C23.063 43.9029 22.9532 43.6379 22.9532 43.3617Z"
        fill="#737A83"
      />
      <path
        d="M43.7866 42.3199H6.28658C5.136 42.3199 4.20325 43.2527 4.20325 44.4033C4.20325 45.5539 5.136 46.4866 6.28658 46.4866H43.7866C44.9372 46.4866 45.8699 45.5539 45.8699 44.4033C45.8699 43.2527 44.9372 42.3199 43.7866 42.3199Z"
        fill="#88BFFF"
      />
      <path
        d="M4.20325 27.7571V25.6738C4.20325 20.7009 6.17871 15.9317 9.69502 12.4155C13.2113 8.89914 17.9804 6.92371 22.9532 6.92371H27.1199C32.0926 6.92371 36.862 8.89914 40.3783 12.4155C43.8945 15.9317 45.8699 20.7009 45.8699 25.6738V27.7571"
        fill="#F4868F"
      />
      <path
        d="M16.7032 27.7571C16.7032 16.2987 20.4324 6.92371 25.0366 6.92371C29.6407 6.92371 33.3699 16.1945 33.3699 27.7571"
        fill="white"
      />
    </svg>
  );
};

export default Vacation;
